import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from 'src/app/pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from 'src/app/pages/common/system/shopinfo/shopinfo.service';
import { ShopinfoModel } from 'src/app/pages/common/system/shopinfo/model/shopinfo.model';
import { DepartmentService } from 'src/app/pages/common/system/department/department.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { HourlySalesReportService } from './hourly-sales-report.service';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-hourly-sales-report',
  standalone: false,
  templateUrl: './hourly-sales-report.component.html',
  styleUrl: './hourly-sales-report.component.scss'
})
export class HourlySalesReportComponent {

  user: UserInfoModel | undefined;
  title: string = "Hourly Sales";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  departmentListData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  permission: any;




  curFinYear!: string; // Add this to your component properties  
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  fromHour: string = '00';
  toHour: string = '00';
  shop_id: any;
  shop_name: any;
  departmentSelectionInvalid: boolean = false;
  resetButtonEnabled: boolean = false;
  isExpandedDepartment = false;
  showSelectedDepartmentOnly = false;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private hourlySalesReportService: HourlySalesReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    const today = new Date();
    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      period_from: this.builder.control(today, Validators.required),
      period_to: this.builder.control(today, Validators.required),
      days: this.builder.group({}),
      percentage_calculation: this.builder.control(0),
      fromHour: this.builder.control('00', Validators.required),
      toHour: this.builder.control('00', Validators.required),
      summary_report: this.builder.control(true),
      departmentFilter: [''],
    }, { validators: this.hourRangeValidator() });

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });
    this.permission = permissionService.getPagePermission("hourly-sales-report");
    // Load saved data if it exists
    // this.loadFromSessionStorage();
    // Set all days as checked by default
    const daysGroup = this.editForm.get('days') as FormGroup;
    this.daysOfWeek.forEach(day => {
      daysGroup.addControl(day, new FormControl(true)); // ✅ checked by default
    });

  }

  ngOnInit(): void {
    // this.loadData();
    this.shopList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    // console.log(this.user)

  }

  selectedDays(): string[] {
    const days = this.editForm.get('days')?.value;
    return Object.keys(days).filter(day => days[day]);
  }

  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('fromHour')?.value;
      const to = group.get('toHour')?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }
  // getCurrentWeek(weeks: any[]): any {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  //   return weeks.find(week => {
  //     const startDate = new Date(week.start_date);
  //     const endDate = new Date(week.end_date);
  //     return today >= startDate && today <= endDate;
  //   });
  // }
  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedDepartmentIds = this.departmentListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const departmentIds = selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
    if (selectedDepartmentIds.length > 0) {
      this.resetButtonEnabled = true;
    } else {
      this.resetButtonEnabled = false;
    }
    // if (shopIds.length === 0) { 
    //   this.departmentSelectionInvalid = true;
    //   return;
    // } else {
    //   this.departmentSelectionInvalid = false; // ✅ clear message when valid
    // }

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: departmentIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    // Save to sessionStorage
    sessionStorage.setItem('hourlySalesReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    // console.log(savedData)
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false }); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.departmentListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.departmentListData.forEach((shop: any) => shop.selected = false);
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }




  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    // console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }





  // loadData(): void {
  //   // console.log('Selected Year:', this.selectedYear);

  //   this.hourlySalesReportService.getWeekNoList().subscribe(response => {
  //     // console.log('API Response:', response);

  //     if (response.status === 'SUCCESS') {
  //       this.financialYears = response.data.finYears;
  //       this.years = this.financialYears.map(fy => fy.year);

  //       // Only set the default value if the form control is empty
  //       if (!this.editForm.get('year')?.value) {
  //         this.curFinYear = response.data.curFinYear;
  //         if (this.curFinYear) {
  //           const yearValue = parseInt(this.curFinYear);
  //           this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

  //           // Set weeks for the current financial year
  //           const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
  //           if (currentFinYear) {
  //             this.weeks = currentFinYear.weeks.map((week: any) => ({
  //               ...week,
  //               displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
  //             }));
  //             // Set the current week as default
  //             const currentWeek = this.getCurrentWeek(this.weeks);
  //             if (currentWeek) {
  //               this.editForm.get('week_no')?.setValue(currentWeek.week_no);
  //             } else if (this.weeks.length > 0) {
  //               // Fallback to first week if current week not found
  //               this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
  //             }
  //           }
  //         }
  //       }

  //       // console.log('Financial Years Data:', this.financialYears);
  //     } else {
  //       console.error('API Error:', response.message);
  //     }
  //   });
  // }
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  shopList(): void {

    let requestData = { search: { filters: { simpleSearch: [], advSearch: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.departmentService.getDepartmentList(requestData).subscribe(
      (response: any) => {
        this.departmentListData = [];
        var index = 0;
        response.data.departments.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.departmentListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }



  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  updateResetButtonState() {
    this.resetButtonEnabled = this.selectedDepartmentSourcesCount > 0;
  }

  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/weekly-result-store-report-view']);
  }

  exportClicked(): void {
    const from = this.editForm.get("period_from")?.value;
    const to = this.editForm.get("period_to")?.value;
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      const diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24);
      if (diff >= 365) {
        this.snackBarService.openSnackBar({
          message: "Please choose a date range shorter than 365 days.",
          type: "warn"
        } as SnackBarData);
        return;
      }
    }
    // console.log(this.editForm.valid)
    if (this.editForm.valid) {

      // Get selected shop IDs (if none are selected, treat it as "ALL")
      const selectedDepartmentIds = this.departmentListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      //  Check: At least one department selected
      // if (selectedDepartmentIds.length === 0) {
      //   this.departmentSelectionInvalid = true;
      //   // this.departmentValidationMessage = 'Please select at least one department.';
      //   return;
      // } else {
      //   this.departmentSelectionInvalid = false; // ✅ clear message when valid
      // }
      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const shopIds = selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
      var rawDateFrom = this.editForm.get('period_from')?.value;
      var formattedDateFrom = moment(rawDateFrom).format('DD-MM-YYYY');
      var rawDateTo = this.editForm.get('period_to')?.value;
      var formattedDateTo = moment(rawDateTo).format('DD-MM-YYYY');
      var days = this.selectedDays();
      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        shopId: this.shop_id,
        shopName: this.shop_name,
        dateFrom: formattedDateFrom,
        dateTo: formattedDateTo,
        departmentId: shopIds,
        days: days,
        prcCal: this.editForm.get('percentage_calculation')?.value,
        hourFrom: this.editForm.get('fromHour')?.value,
        hourTo: this.editForm.get('toHour')?.value,
        summaryReport: this.editForm.get('summary_report')?.value,
        isExport: 1
      };
      this.IsDownloading = true;
      if (reportData) {
        this.hourlySalesReportService.exportHourlySalesReport(reportData).subscribe({
          next: (response) => {
            // Handle "No data found" response
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const text = reader.result as string;
                const json = JSON.parse(text);
                if (json.status === 'NO_DATA_FOUND') {
                  let snackBarData: SnackBarData = {
                    message: 'No data found.',
                    title: 'No Data!!!',
                    type: 'warn'
                  }
                  this.IsDownloading = false;
                  this.snackBarService.openSnackBar(snackBarData);
                  return;
                }
              } catch (e) {
                // Not JSON, treat as file
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'hourly-sales-report.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.IsDownloading = false;
              }
            };
            reader.readAsText(response);
          },
          error: (error) => {
            this.IsDownloading = false;
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    } else {
      this.editForm.markAllAsTouched();

    }
  }

  toggleSelectAllDepartment() {
    const allSelected = this.departmentListData.every((item: any) => item.selected);
    this.departmentListData.forEach((item: any) => (item.selected = !allSelected));
  }

  getSelectAllIconDepartment(): string {
    const allSelected = this.departmentListData.every((item: any) => item.selected);
    const someSelected = this.departmentListData.some((item: any) => item.selected);

    if (allSelected) return 'check_box';
    if (someSelected) return 'indeterminate_check_box';
    return 'check_box_outline_blank';
  }

  get filteredDepartmentListData() {
    let filteredList = this.departmentListData;
    if (this.showSelectedDepartmentOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('departmentFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  get selectedDepartmentSourcesCount(): number {
    return this.departmentListData?.filter((item: any) => item.selected)?.length || 0;
  }
}
